import styles from '../Header.module.scss';

export const Skeleton = ({ width = null, height = 400, borderRadius = 20 }) => {
  return (
    <section className={styles.sceleton}>
      <div className={styles.sceleton_body}>
        <div className={styles.sceleton_wrapper}>
          <div className={styles.sceleton_shimmer}></div>
        </div>
      </div>
    </section>
  );
};
